import React from 'react'
import { SVGIconProps } from '../types'
const SvgViewCompact = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M3 19h6v-7H3zm7 0h12v-7H10zM3 5v6h19V5z" />
  </svg>
)
export default SvgViewCompact
